var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "column",
    attrs: {
      "id": "listen-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "track-list"
    }
  }, _vm._l((_vm.tracklist), function(track) {
    return _c('track-list-item', {
      key: track.track_number,
      attrs: {
        "track": track,
        "soundcloud": _vm.soundcloud
      }
    })
  })), _vm._v(" "), _vm._l((_vm.tracklist), function(track) {
    return _c('soundcloud-player', {
      key: track.track_number,
      attrs: {
        "track": track,
        "soundcloud": _vm.soundcloud
      }
    })
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f859ef44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListenPage/ListenPage.vue
// module id = qUTd
// module chunks = 1